<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        ref="searchForm"
        permpisionsQuery="">
    </qx-search-box>

    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {companyBankcardList, getOtherIncomeSysData} from 'api/getPay';
import {mapState} from 'vuex';
import { saveSearch } from '@qx/utils/cache';
export default {
  components: {
    TableBox,
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 交易时间
      if (searchBoxData.transactionTime && searchBoxData.transactionTime.length) { // 请求时间
        searchBoxData.transactionTimeBegin = this.formatDate(searchBoxData.transactionTime[0]);
        searchBoxData.transactionTimeEnd = this.formatDate(searchBoxData.transactionTime[1]);
        delete searchBoxData.transactionTime;
      }

      if (searchBoxData.accountName) { // 账户名称
        this.searchBoxData.accountNameOptions.map((item) => {
          if (item.bankCardNo === searchBoxData.accountName) {
            searchBoxData.accountName = item.accountName;
          }
        });
      }
      // delete searchBoxData.accountName;


      if (searchBoxData.accountType) { // 账户类型
        if (searchBoxData.accountType.length <= 1) {
          searchBoxData.accountType = searchBoxData.accountType.toString();
          // delete searchBoxData.accountType;
        } else {
          delete searchBoxData.accountType;
        }
      }
      const userId = this.userInfo.staffTFInfo.userId;
      if (searchBoxData.oppositeAccountNumber) {
        saveSearch(`${userId}_opAcctNum`, searchBoxData.oppositeAccountNumber); // 本地存储搜索的内容
      }
      if (searchBoxData.oppositeAccountName) {
        saveSearch(`${userId}_opAcctName`, searchBoxData.oppositeAccountName); // 本地存储搜索的内容
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    async getEnum () {
      const enumsList = await getEnumList({ // 账户类型
        codeType: 'ACCOUNT_TYPE',
      });
      if (enumsList) {
        let data = enumsList[0].filter(function (item) {
          return item.codeId === 128001 || item.codeId === 128002;
        });
        this.searchBoxData.accountTypeOptions = data;
      }

      const transactionPurposeOptionsList = await getOtherIncomeSysData({ // 交易用途
        codeType: 'TRANSACTION_PURPOSE',
      });
      this.searchBoxData.transactionPurposeOptions = [ // 交易用途
        {
          label: '全部',
          value: -1,
        },
        ...transactionPurposeOptionsList[0],
      ];
    },

    async getAccountData () {
      const res = await companyBankcardList({ // 账户名称
        // userId: this.userInfo.staffTFInfo.userId,
        // userType: 2,
        // showMoney: 'true',
      });
      let priObj = {};
      if (res.allPriAcct.length > 0) {
        priObj = res.allPriAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,
        }));
        this.searchBoxData.accountNameOptions.push(...priObj);
      }
      let pubObj = {};
      if (res.allPubAcct.length > 0) {
        pubObj = res.allPubAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号s
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,
        }));
        this.searchBoxData.accountNameOptions.push(...pubObj);
      }
    },
    onSearch (isFrist) { // 历史搜索
      this.isFocus = true;
      const oppositeAcctNumber = this.$refs.searchForm.getVal('oppositeAccountNumber');
      if (oppositeAcctNumber !== '') { // 对方账户搜索框不为空
        saveSearch('_opAcctNum_', oppositeAcctNumber); // 本地存储搜索的内容
        this.isFocus = true;
      }
      const oppositeAcctName = this.$refs.searchForm.getVal('oppositeAccountName');
      if (oppositeAcctName !== '') { // 对方户名搜索框不为空
        saveSearch('_opAcctName_', oppositeAcctName); // 本地存储搜索的内容
        this.isFocus = true;
      }
    },
  },
  data () {
    return {
      isFocus: true,
      searches_list: [], // 历史搜索记录列表
      historyxs: false,
      searchBoxData: {
        accountNameOptions: [], // 账户名称
        transactionPurposeOptions: [], // 交易用途
        accountTypeOptions: [], // 账户类型
        form: [
          { // 交易编号
            label: '交易编号',
            value: 'transactionNoFlow',
            type: 'input',
            placeholder: '请输入交易编号',
          },
          { // 交易时间
            label: '交易时间',
            value: 'transactionTime',
            type: 'date',
            placeholder: '请输入交易时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 账户名称
            label: '账户名称',
            value: 'accountName',
            type: 'select',
            placeholder: '请选择账户名称',
            onvisibilitychange: () => {
              this.searchBoxData.accountNameOptions = [];
              this.getAccountData();
            },
          },
          { // 对方账户
            label: '对方账户',
            value: 'oppositeAccountNumber',
            type: 'el-autocomplete',
            placeholder: '请输入对方账户',
            valueKey: 'oppsiteAcctNum',
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {

                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctNum`));
                searchData.length > 0 && searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctNum: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          { // 对方户名
            label: '对方户名',
            value: 'oppositeAccountName',
            type: 'el-autocomplete',
            placeholder: '请输入对方户名',
            valueKey: 'oppsiteAcctName',
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let searchData = [];
              let filterData = [];
              const userId = this.userInfo.staffTFInfo.userId;
              if (queryString && queryString.length) {
                searchData = JSON.parse(localStorage.getItem(`${userId}_opAcctName`));
                searchData.filter((item) => {
                  if (item.includes(queryString)) {
                    filterData.push({
                      oppsiteAcctName: item,
                    });
                  }
                });
                // this.onSearch(true);
                cb(filterData);
              } else {
                cb(filterData);
              }
            },
          },
          { // 交易用途
            label: '交易用途',
            value: 'transactionPurpose',
            type: 'select',
            default: -1,
            placeholder: '请选择交易用途',
            onvisibilitychange: () => {
              this.searchBoxData.transactionPurposeOptions = [];
              this.getEnum();
            },
          },
          { // 账户类型
            label: '账户类型',
            value: 'accountType',
            type: 'checkbox',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  async created () {
    await this.getEnum();
    await this.getAccountData();
    const userId = this.userInfo.staffTFInfo.userId;
    saveSearch(`${userId}_opAcctNum`, ''); // 进入页面默认存一条对方账户搜索记录为空，解决第一次搜索对方账户时转圈问题
    saveSearch(`${userId}_opAcctName`, ''); // 进入页面默认存一条对方户名搜索记录为空，解决第一次搜索对方账户时转圈问题
  },
};
</script>

<style lang="scss" scoped>
</style>
